import React, { useState } from 'react';
import { Leaf, PackageCheck, Truck, ShieldCheck, ArrowRight } from 'lucide-react';
import { useFlavour } from '../../context/FlavourContext';
import ProductBox from '../../components/ProductBox';
import Reveal from '../../components/Reveal';

const TRUST = [
  { icon: Leaf, label: 'PREMIUM INGREDIENTS' },
  { icon: PackageCheck, label: 'DISCREET PACKAGING' },
  { icon: Truck, label: 'FAST DELIVERY' },
  { icon: ShieldCheck, label: 'SECURE PAYMENT' },
];

export function TrustBar() {
  return (
    <section className="border-y border-white/10 bg-[#0a0a0a]">
      <div className="max-w-[1400px] mx-auto px-5 py-6 grid grid-cols-2 md:grid-cols-4 gap-6">
        {TRUST.map((tr) => (
          <div key={tr.label} className="flex items-center justify-center gap-3 text-center">
            <tr.icon className="w-6 h-6 text-white/60" strokeWidth={1.5} />
            <span className="font-cond tracking-wide text-sm text-white/70">{tr.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export function FiveFlavours() {
  const { order, all, flavourId, setFlavour } = useFlavour();
  const [hover, setHover] = useState(null);

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5">
        <Reveal className="text-center mb-14">
          <h2 className="font-display text-4xl md:text-6xl">ONE FORMULA.<br /><span className="text-flavour flavour-transition">SIX FLAVOURS.</span></h2>
          <p className="font-cond tracking-[0.2em] text-white/50 mt-3">SAME S-MAN. DIFFERENT TASTE.</p>
        </Reveal>

        <div className="flex items-end justify-center gap-3 md:gap-6 flex-wrap">
          {order.map((id) => {
            const active = hover ? hover === id : flavourId === id;
            const dim = hover ? hover === id : false;
            return (
              <button
                key={id}
                onMouseEnter={() => setHover(id)}
                onMouseLeave={() => setHover(null)}
                onClick={() => setFlavour(id, 'five-flavours')}
                className="transition-all duration-300"
                style={{ transform: active ? 'translateY(-24px)' : 'translateY(0)', opacity: hover && !dim ? 0.55 : 1 }}
              >
                <ProductBox flavourId={id} size="md" glow={active} scene />
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
